import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Offer, OfferData } from "../data/offer";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";

@Injectable()
export class OfferService extends OfferData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiOffer: string;
  header: any;
  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }

  async createOffer(data) {
    try {
      let response = await this.http
        .post(this.api + "offer", data)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getOffers(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http
        .post(this.api + "offers", { pagination, filter, order })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getOffer(id: string) {
    try {
      let Offer = <Offer>(
        await this.http.get(this.api + "offer/" + id).toPromise()
      );
      return Offer;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async editOffer(data, id?: string) {
    try {
      let response = <Offer>(
        await this.http
          .put(this.api + "offer/" + (id || ""), data)
          .toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async deleteOffer(id?: string) {
    try {
      let response = <Offer>(
        await this.http.delete(this.api + "offer/" + id).toPromise()
      );
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

}
